// ACTION TYPES FOR CATGEORIES REDUCER
export const CATEGORIES_ACTION_TYPES = {
    SET_CATEGORIES: "SET_CATEGORIES",
};
  